// extracted by mini-css-extract-plugin
export default {"swiper":"RoomMovieCards_swiper__9cY3R","slide":"RoomMovieCards_slide__POJLY","cardsColumn":"RoomMovieCards_cardsColumn__R5uqu"};